/**
 * Utility functions for determining application mode
 */

/**
 * Checks if the application is running in standalone mode
 * Standalone mode means the app is not embedded in an iframe with CFC_PLAYER_DATA
 * @returns {boolean} True if in standalone mode, false if embedded
 */
export const isStandaloneMode = () => {
  return !window.parent.__CFC_PLAYER_DATA__
}
